var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 28,
    viewBox: "0 0 21 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 24.5C1.5 26.15 2.85 27.5 4.5 27.5H16.5C18.15 27.5 19.5 26.15 19.5 24.5V6.5H1.5V24.5ZM4.5 9.5H16.5V24.5H4.5V9.5ZM15.75 2L14.25 0.5H6.75L5.25 2H0V5H21V2H15.75Z",
    fill: "#F37C7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.43c7a8b467bd041cca0a8cacdb7fa49e.svg";
export { ForwardRef as ReactComponent };